// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".retrievalUser[data-v-38b35c7e]:hover {\n  background-color: dodgerblue;\n}", ""]);
// Exports
module.exports = exports;
